import { ReactNode } from 'react'
import { Divider, Menu, MenuItem, Theme } from '@mui/material'
import { SystemStyleObject } from '@mui/system'
import { Link } from 'react-router-dom'
import { SxStyles } from './styles'
import { MenuItemDetails } from '../../layout/topBar/resourceMenu'

interface Props {
  anchorEl: HTMLElement | null
  children?: ReactNode
  icon: React.ReactElement
  menuItems?: MenuItemDetails[]
  sx?: SystemStyleObject<Theme>
  onClose: () => void
  [x: string]: unknown
}

export const Dropdown = ({ anchorEl, children, icon, menuItems, sx, onClose, ...props }: Props) => {
  const open = Boolean(anchorEl)

  return (
    <>
      {icon}
      <Menu
        anchorEl={anchorEl}
        id="user-menu"
        open={open}
        onClose={onClose}
        onClick={onClose}
        autoFocus={false}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{ elevation: 0 }}
        sx={{
          ...sx,
          ...SxStyles,
        }}
        {...props}
      >
        {children ||
          menuItems?.map(({ name, link, external, addDivider, handleItemClick }) => (
            <DropdownItem
              key={name}
              name={name}
              link={link}
              external={external}
              addDivider={addDivider}
              handleItemClick={handleItemClick}
            />
          ))}
      </Menu>
    </>
  )
}

const DropdownItem = ({ name, link, external, addDivider, handleItemClick }: MenuItemDetails) => {
  const shouldPerformActionOnClick = handleItemClick !== undefined && !link

  if (shouldPerformActionOnClick) {
    return (
      <div key={name}>
        {addDivider && <Divider />}
        <MenuItem
          dense
          sx={{ typography: 'body2' }}
          onClick={() => {
            handleItemClick()
          }}
        >
          {name}
        </MenuItem>
      </div>
    )
  }

  return (
    <div key={name}>
      {addDivider && <Divider />}
      {external ? (
        <a key={name} href={link ?? undefined} target="_blank" rel="noreferrer">
          <MenuItem dense sx={{ typography: 'body2' }}>
            {name}
          </MenuItem>
        </a>
      ) : (
        <Link key={name} to={link ?? ''}>
          <MenuItem dense sx={{ typography: 'body2' }}>
            {name}
          </MenuItem>
        </Link>
      )}
    </div>
  )
}
